export default __webpack_public_path__ + "img/cda029a53181d4ee51e8bb3b22cb1289.svg";